var map = {
	"./production_new_h_quiz_variant_1.json": [
		51519,
		1519
	],
	"./production_new_h_quiz_variant_2.json": [
		20148,
		148
	],
	"./production_new_t_quiz_variant_1.json": [
		73198,
		3198
	],
	"./production_new_t_quiz_variant_2.json": [
		81406,
		1406
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70951;
module.exports = webpackAsyncContext;